import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import { useDispatch } from "react-redux";
import { mainCategories } from "../../../actions/mainCategory";
import { retreive, edit } from "../../../actions/childCategory";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Alert from "../../../components/alert/alert.component";
import HeadingPrimary from "../../../components/custom-heading/heading-primary";
import HeadingSecondary from "../../../components/custom-heading/heading-secondary";
import CustomInput from "../../../components/custom-input/custom-input";
import CustomTextArea from "../../../components/custom-input/custom-textarea";
import CustomRadioInput from "../../../components/custom-input/custom-radio-input";
import CustomButton, {
  CustomButtonClasses,
  CustomButtonTypes,
} from "../../../components/custom-button/custom-button";
import ImageUploaderField from "../../../components/img-uploader-field/img-uploader-field";
import MultiValueSelect from "../main-category/components/multi-value-select/multi-value-select";
import ChildCategoryInputSelect from "./components/drop-down-select";

const Edit = () => {
  const dispatch = useDispatch();
  const query = new URLSearchParams(window.location.search);
  const id = query.get("id");

  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    mainCategoryId: null,
    name: "",
    displayName: "",
    slug: "",
    description: "",
    metaTag: [],
    metaDescription: "",
    metaKeyword: [],
    seoKeyword: [],
    mainCategoriesList: null,
    show: true,
    image: "",
    isBase64: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const _res = await dispatch(mainCategories());
        setFormData((prev) => ({
          ...prev,
          mainCategoriesList: _res?.mainCategories,
        }));

        const res = await dispatch(retreive(id ?? ""));

        const metaTagData = res?.metaTag?.map((element) => ({
          value: element,
          label: element,
        }));

        const metaKeywordData = res?.metaKeyword?.map((_element) => ({
          value: _element,
          label: _element,
        }));

        const seoKeywordData = res?.seoKeyword?.map((element) => ({
          value: element,
          label: element,
        }));

        setFormData((prev) => ({
          ...prev,
          name: res?.name,
          displayName: res?.displayName,
          slug: res?.slug,
          description: res?.description,
          metaDescription: res?.metaDescription,
          mainCategoryId: res?.mainCategoryId,
          metaTag: metaTagData,
          metaKeyword: metaKeywordData,
          seoKeyword: seoKeywordData,
          image: res?.image,
          show: res?.show,
        }));

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    return () => setLoading(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submitHandler = async () => {
    setLoading(true);

    const {
      name,
      description,
      slug,
      mainCategoryId,
      image,
      metaTag,
      metaDescription,
      metaKeyword,
      seoKeyword,
      show,
      isBase64,
      displayName,
    } = formData;

    // Extracting values from metaTag, metaKeyword, and seoKeyword arrays
    const metaTagData = metaTag?.map((element) => element.value);
    const metaKeywordData = metaKeyword?.map((element) => element.value);
    const seoKeywordData = seoKeyword?.map((element) => element.value);

    // Creating dataToSend object
    const dataToSend = {
      _id: id,
      name,
      displayName,
      slug,
      mainCategoryId,
      image,
      metaTag: metaTagData,
      metaDescription,
      metaKeyword: metaKeywordData,
      seoKeyword: seoKeywordData,
      description,
      show,
      isBase64,
    };

    const res = await dispatch(edit(dataToSend));
    setLoading(false);

    if (res) {
      toast(`${res.data}`, { containerId: "B" });
    }
  };

  const handleImageChange = async (e) => {
    const base64 = await toBase64(e[0]);
    setFormData((prev) => ({
      ...prev,
      image: base64,
      isBase64: true,
    }));
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const changeInputTags = (e, key) => {
    const data = e?.map((item) => ({
      value: item.value,
      label: item.value,
    }));
    setFormData((prev) => ({ ...prev, [key]: data }));
  };

  const handleChange = (e) => {
    e.persist();
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getOptions =
    Array.isArray(formData?.mainCategoriesList) &&
    formData?.mainCategoriesList?.map((item) => ({
      value: item?._id,
      label: item?.name,
    }));

  return (
    <div className="container-scroller">
      {loading && <TopBarProgress />}

      <ToastContainer
      stacked 
        enableMultiContainer
        containerId={"B"}
        // position={toast.POSITION.TOP_RIGHT}
          position="top-right" // Hardcoded position
      />

      <div className="page-header">
        <HeadingPrimary>Edit Child Category</HeadingPrimary>
        <div style={{ fontSize: ".9rem" }}>
          <Link to="/admin/child-categories">Child Categories </Link>
          /&nbsp;Edit Child Category
        </div>
      </div>

      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card p-0" style={{ border: "1px solid #dcdcdc" }}>
            <div className="card-body p-0">
              <HeadingSecondary>Edit Child Category</HeadingSecondary>
              <Alert />

              <form className="forms-sample m-3">
                <CustomInput
                  label="Name"
                  name="name"
                  type="text"
                  placeholder="Name"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData?.name}
                />

                <CustomInput
                  label="Display Name"
                  name="displayName"
                  type="text"
                  placeholder="Name"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData?.displayName}
                />

                <CustomInput
                  label="Slug"
                  name="slug"
                  type="text"
                  placeholder="Slug"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData.slug}
                />

                <ChildCategoryInputSelect
                  label="Select parent category"
                  options={getOptions || []}
                  value={formData.mainCategoryId}
                  name="mainCategoryId"
                  onChange={handleChange}
                />

                <ImageUploaderField
                  labelStyles={{ fontWeight: "bold" }}
                  label="Image upload"
                  buttonText="Choose image"
                  name="image"
                  onChange={(e) => handleImageChange(e)}
                />

                <div className="form-group">
                  <img
                    src={formData?.image && formData?.image}
                    alt="main-img"
                    width="100"
                    height="auto"
                  />
                </div>

                {!loading && (
                  <MultiValueSelect
                    label="Meta Tags"
                    defaultValue={formData?.metaTag}
                    name="metaTags"
                    labelStyles={{ fontWeight: "bold" }}
                    onChange={(value) => changeInputTags(value, "metaTag")}
                  />
                )}

                {/* <div className="form-group">
                  <label htmlFor="Meta Tags">Meta Title</label>
                  {!loading && metaTagJsx()}
                </div> */}

                {!loading && (
                  <MultiValueSelect
                    label="Meta Keywords"
                    defaultValue={formData?.metaKeyword}
                    name="metaKeyword"
                    labelStyles={{ fontWeight: "bold" }}
                    onChange={(value) => changeInputTags(value, "metaKeyword")}
                  />
                )}

                <CustomTextArea
                  label="Meta Description"
                  labelStyles={{ fontWeight: "bold" }}
                  name="metaDescription"
                  rows={6}
                  value={formData.metaDescription}
                  onChange={handleChange}
                />

                {!loading && (
                  <MultiValueSelect
                    label="Seo Keywords"
                    defaultValue={formData?.seoKeyword}
                    name="seoKeyword"
                    labelStyles={{ fontWeight: "bold" }}
                    onChange={(value) => changeInputTags(value, "seoKeyword")}
                  />
                )}

                <CustomTextArea
                  label="Seo Description"
                  labelStyles={{ fontWeight: "bold" }}
                  name="description"
                  rows={6}
                  value={formData.description}
                  onChange={handleChange}
                />

                <div className="form-group">
                  <label
                    style={{ fontWeight: "bold" }}
                    className="col-sm-3 col-form-label"
                  >
                    Show in Header
                  </label>
                  <div className="col-sm-12">
                    <CustomRadioInput
                      label="Yes"
                      required={true}
                      type="radio"
                      id="radio1"
                      name="membershipRadios"
                      checked={formData?.show === true}
                      labelStyles={{ fontWeight: "bold" }}
                      value={formData.show}
                      onChange={() => setFormData({ ...formData, show: true })}
                    />
                  </div>
                  <div className="col-sm-5">
                    <CustomRadioInput
                      label="No"
                      required={true}
                      type="radio"
                      name="membershipRadios"
                      id="radio2"
                      checked={formData?.show === false}
                      labelStyles={{ fontWeight: "bold" }}
                      value={formData.show}
                      onChange={() => setFormData({ ...formData, show: false })}
                    />
                  </div>
                </div>

                <CustomButton
                  type={CustomButtonTypes.BUTTON}
                  className={CustomButtonClasses.PRIMARY}
                  onClick={submitHandler}
                >
                  Update
                </CustomButton>

                <Link to={"/admin/child-categories"}>
                  <CustomButton
                    className={CustomButtonClasses.LIGHT}
                    type={CustomButtonTypes.BUTTON}
                  >
                    Cancal
                  </CustomButton>
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
